import Machine from '../../../../../types/api/machine'
import { Zones } from '../../../../../types/api/print-queue-entry'
import { materialRequirementsPopulate } from '../../../../schedules/flexo/constants/shipment-populate'

export const getQueryParams = (machine: Machine) => ({
    filters: {
        zone: { $eq: Zones.Main },
        machine: {
            documentId: {
                $eq: machine.documentId,
            },
        },
    },
    populate: {
        machine: true,
        rewind_job: {
            populate: {
                rewind_job_executors: {
                    populate: {
                        user: true,
                    },
                },
                shipment: {
                    populate: {
                        client: true,
                        shipment_positions: true,
                        print_job: true,
                        materialRequirements: { populate: materialRequirementsPopulate },
                        stamp: true,
                        virtualStamp: true,
                    },
                },
            },
        },
    },
    sort: ['sort:asc'],
    pagination: { pageSize: 500, page: 1 },
})
